import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Divider, Label } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';
import { formatDate } from '@scope/scope-one-ui/global/utils';
import { PortfolioNewsWidgetProps } from './PortfolioNewsWidget.d';
import { ScrollableArea, WidgetItem, WidgetStyled } from './PortfolioSummary.styled';

const artifactTypesLabels = {
  rating_news: 'RATING NEWS',
  research: 'RESEARCH',
};

export const PortfolioNewsWidget: FC<PortfolioNewsWidgetProps> = ({ latestNews }) => {
  const { t } = useTranslation();

  const goToTab = (artifactId: string) => {
    window.location.href = `/page-one/news/${artifactId}`;
  };

  const convertDate = (publicationDate: string) => formatDate(publicationDate);

  return (
    <WidgetStyled title={t('PORTFOLIO.PORTFOLIO_NEWS')}>
      <ScrollableArea showScroll={latestNews.length > 3}>
        {latestNews.map((item) => (
          <Box display="flex" flexDirection="column" onClick={() => goToTab(item.artifactId)}>
            <WidgetItem py={3}>
              <Box mx={2.5} display="flex" alignItems="start" flexDirection="column">
                <Box display="flex" alignItems="center" mb={1.5}>
                  <Typography color={COLORS.typography.main} variant="body1">
                    {convertDate(item.publicationDate)}
                  </Typography>
                  <Box mx={2}>
                    <Label size="small">{artifactTypesLabels[item.type]}</Label>
                  </Box>
                </Box>
                <Typography variant="h3">{item.title}</Typography>
              </Box>
            </WidgetItem>
            <Box mx={2}>
              <Divider />
            </Box>
          </Box>
        ))}
      </ScrollableArea>
    </WidgetStyled>
  );
};

export default PortfolioNewsWidget;
